import { NgModule } from '@angular/core';
import { PhxCommentFieldComponent } from './phx-comment-field.component';
import { CommonModule } from '@angular/common';
import { PhxInputModule } from '../input/phx-input.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxDividerModule } from '../divider/phx-divider.module';
import { PhxCheckboxModule } from '../checkbox/checkbox.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';

@NgModule({
  imports: [
    CommonModule,
    PhxInputModule,
    PhxIconModule,
    PhxDividerModule,
    PhxCheckboxModule,
    PhxTranslationsRootModule
  ],
  declarations: [PhxCommentFieldComponent],
  exports: [PhxCommentFieldComponent],
})
export class PhxCommentFieldModule { }